import { ChangeDetectionStrategy, Component, EventEmitter, input, InputSignal, Output } from '@angular/core';

@Component({
  selector: 'sz-radio-card',
  templateUrl: './sz-radio-card.component.html',
  styleUrls: ['./sz-radio-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class SzRadioCardComponent {
  readonly label: InputSignal<string> = input.required<string>();
  readonly description: InputSignal<string | null> = input<string | null>(null);
  readonly selected: InputSignal<boolean> = input<boolean>(false);
  readonly disabled: InputSignal<boolean> = input<boolean>(false);

  @Output() readonly select: EventEmitter<void> = new EventEmitter<void>();

  emit(): void {
    if (this.disabled()) {
      return;
    }
    this.select.emit();
  }
}
